import * as React from 'react';
import { TargetPanel } from 'app/area/reports/containers/target/components/target-panel';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { TargetState } from 'app/area/reports/containers/target/types-store';
import { useActionCreators, useLoadDefaultFieldsEffect } from 'app/area/reports/containers/target/hooks';
import { ComplexValue } from 'ui';

export interface TargetContainerProps { 
  orderNumber: string;
  disabled: boolean;
  targetFieldState: TargetState;
  translation: any;
  selectedTargetApplication: ComplexValue<number>;
}

export const TargetContainerForApi = (api: ReportCommonApi) => ({
  orderNumber,
  disabled,
  targetFieldState,
  translation,
  selectedTargetApplication
}: TargetContainerProps) => {

  const {
    loadFields,
    updateDefaultFields,
    clearValue,
    onSelectField
  } = useActionCreators(api);

  useLoadDefaultFieldsEffect(api);

  return <TargetPanel
    disabled={disabled}
    orderNumber={orderNumber}
    fetching={targetFieldState.fetching}
    data={targetFieldState}
    onLoadFields={loadFields}
    onUpdateDefaultFields={updateDefaultFields}
    onRemove={clearValue}
    onSelect={onSelectField}
    translation={translation}
    selectedTargetApplication={selectedTargetApplication}
  />;
};
